var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotifyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_402_6506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.72392 7.37205C3.72304 6.74339 3.8466 6.12077 4.08747 5.54008C4.32834 4.9594 4.68176 4.43213 5.12736 3.98867C5.57296 3.54522 6.10192 3.19434 6.68376 2.95626C7.26559 2.71819 7.8888 2.59763 8.51744 2.60153C11.1406 2.62103 13.2388 4.80142 13.2388 7.43193V7.90212C13.2388 10.2752 13.7353 11.6523 14.1726 12.405C14.2197 12.4854 14.2448 12.5768 14.2453 12.67C14.2458 12.7632 14.2217 12.8549 14.1755 12.9358C14.1292 13.0167 14.0624 13.084 13.9819 13.1309C13.9013 13.1778 13.8098 13.2026 13.7166 13.2028H3.24557C3.15235 13.2026 3.06085 13.1778 2.98029 13.1309C2.89973 13.084 2.83297 13.0167 2.78673 12.9357C2.74049 12.8548 2.71641 12.7631 2.71693 12.6699C2.71744 12.5767 2.74253 12.4853 2.78966 12.4048C3.22719 11.6522 3.72391 10.2751 3.72391 7.90212L3.72392 7.37205Z",
    stroke: "#181819",
    strokeWidth: 1.41352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36084 13.2029V13.7329C6.36084 14.2953 6.58423 14.8346 6.98186 15.2322C7.37949 15.6298 7.91879 15.8532 8.48113 15.8532C9.04346 15.8532 9.58276 15.6298 9.9804 15.2322C10.378 14.8346 10.6014 14.2953 10.6014 13.7329V13.2029",
    stroke: "#181819",
    strokeWidth: 1.41352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_402_6506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.9623,
    height: 16.9623,
    fill: "white",
    transform: "translate(0 0.48114)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyIcon);
export default __webpack_public_path__ + "static/media/notify-icon.af52008dec1d961497e2ea6a52e04511.svg";
export { ForwardRef as ReactComponent };